import { Modal, ModalId } from "../../../../../features/ui"

type Props = {
    onSubmit?: () => void
}

export const RoadmapWeightWarningModal = (props: Props) => {
    const { onSubmit } = props

    return (
        <Modal
            modalId={ModalId.ROADMAP_WEIGHT_WARNING}
            title="Carga Excesiva Detectada"
            submitLabel="Ignorar y Crear Hoja de Ruta"
            cancelLabel="Editar Hoja de Ruta"
            widthSize="s"
            onSubmit={onSubmit}
        >
            <p>Se ha detectado que el peso total de los envíos seleccionados supera la capacidad de carga del vehículo.</p>
        </Modal>
    )
}
